import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topbar from "../../shared/components/Topbar";
import Footer from "../../shared/components/Footer";
import Breadcrumb from "../../shared/components/Breadcrumb";
import Clinicheader from "../clinic/Clinicheader";
import DoctorLogin from "./DoctorLogin";
import DoctorSidebar from "./DoctorSidebar";
import toast from "react-hot-toast";

export default function DoctorLayout() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    setIsChecking(true);
    const token = localStorage.getItem("DToken");
    const loginDetails = localStorage.getItem("LoginDetails");
    if (!token || loginDetails !== "Doctor") {
      setIsLoggedIn(false);
      setIsChecking(false);
      return;
    }

    // Verify token quickly.
    fetch(window.API_PREFIX + "admin/doctordetail", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ Token: token }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "1") {
          if (data?.data?.DoctorId)
            localStorage.setItem("doctorId", data.data.DoctorId);
          if (data?.data?.ClinicId)
            localStorage.setItem("clinicId", data.data.ClinicId);
          localStorage.setItem(
            "doctorShowTransaction",
            Number(data?.data?.ShowTransaction || 0) === 1 ? "1" : "0"
          );
          setIsLoggedIn(true);
          setIsChecking(false);
        } else if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          setIsLoggedIn(false);
          setIsChecking(false);
        } else {
          setIsLoggedIn(false);
          setIsChecking(false);
        }
      })
      .catch(() => {
        setIsLoggedIn(false);
        setIsChecking(false);
      });
  }, [location.pathname]);

  if (isChecking) return null;
  if (!isLoggedIn)
    return (
      <>
        <Topbar />
        <Clinicheader /> <DoctorLogin />
        <Footer />
      </>
    );

  return (
    <>
      <Topbar />
      <Clinicheader />

      <Breadcrumb />
      <div className="slidebar_and_component">
        <DoctorSidebar />
        <div className="outlet_main_div">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
